import { createBreakpoint, createMap } from "styled-components-breakpoint";
import { breakpoints } from "../../settings";

export const breakpoint = createBreakpoint(breakpoints);
export const map = createMap(breakpoints);
